if (!customElements.get('responsive-hero-video')) {
  customElements.define('responsive-hero-video', class extends HTMLElement {
    connectedCallback() {
      if (this.mediaQuery) return;

      this.video = this.querySelector('video');
      if (!this.video) return;

      this.mediaQuery = window.matchMedia('(max-width: 768px)');
      this.updateSource = this.updateSource.bind(this);
      this.mediaQuery.addEventListener('change', this.updateSource);
      this.updateSource();
    }

    disconnectedCallback() {
      if (this.mediaQuery && this.updateSource) {
        this.mediaQuery.removeEventListener('change', this.updateSource);
      }

      this.mediaQuery = null;
      this.video = null;
    }

    updateSource() {
      const source = this.mediaQuery.matches
        ? this.dataset.mobileSrc
        : this.dataset.desktopSrc;

      if (!source) {
        this.hidden = true;
        if (this.video.currentSrc || this.video.getAttribute('src')) {
          this.video.pause();
          this.video.removeAttribute('src');
          this.video.load();
        }
        this.dataset.currentSrc = '';
        return;
      }

      this.hidden = false;
      if (this.dataset.currentSrc === source) return;

      this.video.pause();
      this.video.src = source;
      this.dataset.currentSrc = source;
      this.video.load();

      const playPromise = this.video.play();
      if (playPromise) playPromise.catch(() => {});
    }
  });
}
